import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetchPositionsList } from "src/Pages/Company/OrganizationStructure/api";
import { UsePositionsListParams } from "src/Pages/Company/OrganizationStructure/Positions/positions.models";

export const usePositionsList = ({
  companyId,
  structureId,
  page,
  size,
  sort,
  filters,
  enabled = true,
}: UsePositionsListParams) =>
  useQuery({
    enabled: enabled && !!companyId && !!structureId,
    queryKey: [
      "positions-list",
      companyId,
      structureId,
      page,
      size,
      sort,
      filters,
    ],
    queryFn: () =>
      fetchPositionsList({
        companyId,
        structureId,
        page,
        size,
        sort,
        filters,
      }),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
